import { BaseSortPlainObject } from './baseSort.plainObject';
import { ColumnPlainObject } from './column.plainObject';

export class RankPlainObject extends BaseSortPlainObject {
    public keyColumn: ColumnPlainObject;
}
